import React from 'react';
import cx from 'classnames';

import './index.scss';

const getFirstCharecter=(business_name)=>{
    if(business_name && business_name.length>0){
        return business_name.charAt(0)
    }
    return 'T'
}
const Dentalbody = ({message,logo,business_name,actioncolor,brandcolor,usermessage,emailInit, email_capture_message}) => {
  return (
                 <div className="preview-body">
                    <div className="close-btn">X</div>      
                    <div className="question-no">2 of 4</div>
                    <div className="question">When would you like to come in?</div>   
                    <div className="action-group">
                        <div className="action-group_select" style={{color:actioncolor}}>Selected</div>
                        <div className="action-group_month">MAR 2021</div> 
                        <div className="action-group_today" style={{color:actioncolor}}>Today</div>     
                    </div>  
                    <div className="table">
                        <div style={{backgroundColor:brandcolor}} className="header">
                            <div className="column"><i className="material-icons">chevron_left</i></div>
                            <div className="column">
                                <div className="day">MON</div>
                                <div className="date">Mar 15</div>
                            </div>
                            <div className="column">
                                <div className="day">TUE</div>
                                <div className="date">Mar 16</div>
                            </div>
                            <div className="column">
                                <div className="day">WED</div>
                                <div className="date">Mar 17</div>
                            </div>
                            <div className="column"><i className="material-icons">chevron_right</i></div>
                        </div>
                        <div className="body">
                            <div className="data-empty"></div>
                            <div className="data">
                                <div className="slot">
                                    09:00 am
                                </div>
                            </div>
                            <div className="data">
                                <div className="slot">
                                    09:00 am
                                </div>
                            </div>
                            <div className="data">
                                <div className="slot">
                                    09:00 am
                                </div>
                            </div>
                            <div className="data-empty"></div>
                        </div>
                    </div>   
                    <div className="table-footer">
                    <div className="navigation">
                        <div  className='action'>   
                            <div className="icon-container"><i className="material-icons">arrow_back</i></div>      
                        </div>
                        <div  className='action'>   
                            <div className="icon-container"><i className="material-icons">arrow_forward</i></div>    
                        </div>
                    </div>
                    <div className="powered-by-booking">Powered by <a href="https://truelark.com/" target="_blank" rel="noopener noreferrer" >TrueLark</a></div>
                    </div>   
                 </div>
  );
};

export default Dentalbody;
